export class PayrollInformationBO {
    id: string="00000000-0000-0000-0000-000000000000";
    employeeId: string;
    withHoldingLid: string;
    withHoldingName: string;
    paycheckTypeLid: string;
    paycheckTypeName: string;
    bankRounting: string;
    accountNumber: string;
    exemptionsNumber: string;
    otherPayrollInfo: string;
    allCompanyPayrollID: string;
}

export class WorkHistoryBO {
    id: string="00000000-0000-0000-0000-000000000000";
    hireDate: string;
    inactiveDate: string;
    termDate: string;
    employeeId: string;
    clientId: string;
    agencyId: string;
    clientName: string;
}

export class GetListBaseHistoryBO {
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string="clientName";
    orderType: string ;
    type: string = "string";
    field: string="clientName";
    operator: string = "contains";
    value: string = "";
    matchCase: boolean = false;
    employeeId: string;    
  }
  
  export class WhereCondition {
    field: string="hireDate";
    value: string="";
    operator: string="startswith";
    orderNo: number=1;
    predicate: string="and";
    type: string="string";
    matchCase:boolean=false;
}


export class AccountNumberShowBO {
    admin_Password: string;
    fieldname: string;
    employeeId: string;
     tableType :string;
}
